import { BuildContextProvider } from '../../providers';
import { Renderer } from './renderer';
import type { Props } from './types';

export function Resolver({ entries, pageId }: Props) {
    return (
        <BuildContextProvider pageId={pageId}>
            <Renderer entries={entries} />
        </BuildContextProvider>
    );
}
